import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { A5EventRow, useA5EventColumns } from "./columns";
import { FilterA5Events, type FilterA5EventsSchema } from "./filter";

const client = "a5";
const table_name = "a5_events";

export function A5EventsTable() {
  const { t } = useTranslation();
  const columns = useA5EventColumns();

  return (
    <Table<A5EventRow, FilterA5EventsSchema>
      label={t(`${table_name}.title`, { ns: "tables", defaultValue: "Events" })}
      client={client}
      table_name={table_name}
      columns={columns}
      columnVisibilityInit={{ created_at: false, updated_at: false }}
      filter={<FilterA5Events />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
}
